import { useDispatch, useSelector } from 'react-redux';
import DmPassport from './DmPassport/DmPassport'
import DmGNSS from './DmGNSS/DmGNSS'
import DmPressure from './DmPressure/DmPressure'
import DmSufety from './DmSufety/DmSufety'
import './DmConfig.css'

export default function DmConfig() {
    const parameter = useSelector((state) => state.dmimei?.data[0]);
   
    return(
        <div className="dmConfigCard">  
           <DmPassport  />
           <DmGNSS  />
           <DmPressure  />
           {String(parameter?.imei).slice(0,3)!=="555" && <DmSufety />}
        </div>
    )
} 